import Parking from './parking'
export default Parking
